import {AccountMetaData} from  '../config/settings';

const getEnv = (key) => {
    return (window._env_ && window._env_[key]) || process.env[key];
};

const LOCAL_API_URL_PATTERN = /^https?:\/\/(?:localhost|127\.0\.0\.1|0\.0\.0\.0)(?::\d+)?(?:\/|$)/i;
const DEFAULT_UPLOAD_API_BASE_URL = 'https://crm.fumeesoft.com';

/**
 * Local frontend still uses its local API for normal development requests, but
 * uploaded catalog images must be available to the shared RAG/knowledge stack.
 */
export const getUploadApiBaseUrl = () => {
    const configuredBaseUrl = getEnv('REACT_APP_API_CHOTSALE_URL');
    if (!configuredBaseUrl || LOCAL_API_URL_PATTERN.test(configuredBaseUrl)) {
        return DEFAULT_UPLOAD_API_BASE_URL;
    }
    return configuredBaseUrl.replace(/\/+$/, '');
};

export const apis = {
    host: getEnv('REACT_APP_API_CHOTSALE_URL') + '/api/v1',
    api_key: getEnv('REACT_APP_API_CHOTSALE_KEY'),
    post_mes: {
        inbox: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/InboxController.php',
        reply: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/ReplyController.php',
        sendNew: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/InboxNewUserController.php',
        MarkSeen: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/MarkSeen.php',
        markSeenAll: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/MarkSeenAll.php',
        DeleteDirect: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/DeleteDirect.php',
        DeleteComment: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/DeleteComment.php',
        ConvertCode: getEnv('REACT_APP_API_INSTAGRAM_SV') + '/ConvertCode.php',
    },
    app: {
        face_id: {
            check_phone: "api/v1/faceid/check_phone",
            index: "api/v1/faceid",
            log: "api/v1/face_data/log",
            insert: "api/v1/faceid/insert",
            remove: "api/v1/faceid/remove",
            log2: "api/v1/face_data/log2",
            note: "api/v1/face_data/note",
            check: "api/v1/face_data/check",
        },
        thuphi: {
            list_bn_thuphi_goimo: "api/v1/thuphi/bn_goimo"
        }
    },
    chat: {
        send2: "api/v1/chat/fanpagefb/send2"
    }
}

export function fetchData(data = {}){
    let baseUrl = getEnv('REACT_APP_API_CHOTSALE_URL') || window.location.origin;
    
    // Check if the URL belongs to the RAG service
    if (data['url'] && /^(?:retrieval|ingestion)\//.test(data['url']) && getEnv('REACT_APP_RAG_SERVICE_URL')) {
        baseUrl = getEnv('REACT_APP_RAG_SERVICE_URL');
    }

    let url = `${baseUrl}/${data['url']}`; 
    let options = {
        method: data.method ? data.method : 'GET',
        headers: {
            Authorization: `${AccountMetaData.getToken()}`,
            Company: AccountMetaData.getCompanyId()
        }
    };
    if(options.method.toLocaleLowerCase() != 'get'){
        options['body'] = data.data;
    }

    if(data.type_post != 'upload_image'){
        options['headers']['Content-Type'] = 'application/json';
        options['body'] = JSON.stringify(options['body']);
    }

    if(data.params){
        let location = new URL(url);
        Object.keys(data.params).forEach((key) => {
            location.searchParams.set(key, data.params[key]);
        })
        url = location.href;
    }
    
    return new Promise((resolve, reject) => {
        fetch(url, {
            withCredentials: true,
            credentials: 'include',
            crossDomain: true,
            ...options
        })
        .then(response =>  {
            // console.log('response');
            if(data['type_api']== 2){
                return response.text().then(function(text) {
                    try {
                        let result = text ? JSON.parse(text) : {
                            status: 404,
                            message: 'Đã có lỗi xảy ra, vui lòng thử lại sau!'
                        };
                        return result;
                    } catch (err) {
                        console.log(err);
                        return {
                            status_code: 500,
                            message: 'Da co loi'
                        };
                    }
                })
            } else{
                return response.json();
            }
        })
        .then((response) => {
            if(response.code && response.code != 200 || response.status_code && response.status_code != 200) return reject(response);
            return resolve(response);
        }).catch((err) => {
            return reject({
                code: 500,
                err: err
            });
        })
    })
}
